"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressScreen = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./ProgressScreen.css"));
var parentStyles = __importStar(require("./DocUploader.css"));
var axios_1 = __importDefault(require("axios"));
var ProgressBar_1 = require("Common/ProgressBar/ProgressBar");
var DocUploader_1 = require("./DocUploader");
var lodash_1 = require("lodash");
var CrossFade_1 = require("@CommonFrontend/CrossFade/CrossFade");
var initialProgressLevel = 45;
var minimumProgressLevel = 55;
var maximumProgressLevel = 95;
var ProgressScreen = function (_a) {
    var file = _a.file, apiBaseUrl = _a.apiBaseUrl, onComplete = _a.onComplete, onCancel = _a.onCancel, eventOrigin = _a.eventOrigin;
    var _b = __read((0, react_1.useState)(""), 2), uploadId = _b[0], setUploadId = _b[1];
    var _c = __read((0, react_1.useState)(""), 2), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), isPolling = _d[0], setIsPolling = _d[1];
    var _e = __read((0, react_1.useState)(0), 2), progress = _e[0], setProgress = _e[1];
    var pollingTimeout = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        var uploadFile = function (file) { return __awaiter(void 0, void 0, void 0, function () {
            var s3UrlResponse, formData, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4, axios_1.default.get("".concat(apiBaseUrl, "/upload-destination?fileName=").concat(encodeURIComponent(file.name), "&eventOrigin=").concat(eventOrigin), {
                                withCredentials: true,
                            })];
                    case 1:
                        s3UrlResponse = _a.sent();
                        setProgress(initialProgressLevel);
                        if (!s3UrlResponse.data.url) return [3, 3];
                        formData = new FormData();
                        formData.append("file", file, file.name);
                        return [4, axios_1.default.put(s3UrlResponse.data.url, formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                            })];
                    case 2:
                        _a.sent();
                        setUploadId(s3UrlResponse.data.uploadId);
                        setIsPolling(true);
                        return [3, 4];
                    case 3: throw new Error("No upload url returned from /upload-destination");
                    case 4: return [3, 6];
                    case 5:
                        error_1 = _a.sent();
                        setErrorMessage("Oops! Something went wrong. It looks like a technical issue or an unstable internet connection. Please try again.");
                        return [3, 6];
                    case 6: return [2];
                }
            });
        }); };
        if (file) {
            uploadFile(file);
        }
        else {
            setErrorMessage("Oops! Something went wrong uploading file. Please try again.");
        }
    }, [apiBaseUrl, file]);
    (0, react_1.useEffect)(function () {
        var wait = 5000;
        var maxTries = 60;
        var counter = 1;
        var updateProgressBar = function (data) {
            var _a, _b;
            var totalPages = data.numberOfPages;
            var completedPages = (_b = (_a = data.pageIds) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
            var projectId = data.projectId;
            if (totalPages) {
                if (completedPages <= totalPages && !projectId) {
                    var minProgress = minimumProgressLevel;
                    var maxProgress = maximumProgressLevel;
                    var approxProgress = (0, lodash_1.clamp)((completedPages / totalPages) * 100, minProgress, maxProgress);
                    setProgress(approxProgress);
                }
                if (completedPages === totalPages && projectId) {
                    setIsPolling(false);
                    setProgress(100);
                    setTimeout(function () {
                        onComplete(projectId);
                    }, 500);
                }
            }
        };
        var check = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!uploadId) return [3, 2];
                        return [4, axios_1.default.get("".concat(apiBaseUrl, "/document-status/").concat(uploadId), {
                                withCredentials: true,
                            })];
                    case 1:
                        response = _a.sent();
                        updateProgressBar(response.data);
                        if (counter >= maxTries) {
                            setIsPolling(false);
                            setErrorMessage("Generating page is taking longer than expected, please check back later.");
                        }
                        else {
                            counter++;
                            pollingTimeout.current = setTimeout(function () {
                                check();
                            }, wait);
                        }
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        }); };
        if (isPolling) {
            check();
        }
        return function () {
            if (pollingTimeout.current) {
                clearTimeout(pollingTimeout.current);
            }
        };
    }, [isPolling, uploadId, apiBaseUrl, onComplete]);
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m", align: "center", justify: "center" },
        !!errorMessage && react_1.default.createElement(DocUploader_1.ErrorStrap, { text: errorMessage }),
        react_1.default.createElement(LoadingMessages, { progress: progress }),
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.progressBarContainer },
            react_1.default.createElement(ProgressBar_1.ProgressBar, { percent: progress })),
        react_1.default.createElement(kaleidoscope_1.Stack, { paddingTop: "m", align: "center", justify: "center" },
            react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, onClick: function () {
                    setIsPolling(false);
                    onCancel();
                } }, "Cancel upload"))));
};
exports.ProgressScreen = ProgressScreen;
var LoadingMessages = function (_a) {
    var _b, _c;
    var progress = _a.progress;
    var _d = __read((0, react_1.useState)(0), 2), counter = _d[0], setCounter = _d[1];
    var _e = __read((0, react_1.useState)("start"), 2), state = _e[0], setState = _e[1];
    var loopingInterval = (0, react_1.useRef)();
    var uploadStartedMessage = {
        heading: "Uploading Doc",
        text: "This can take up a minute or two for large files",
    };
    var loopingMessages = [
        { heading: "Cooking up some AI magic", text: "Stick to a clear, logical structure. Clarity builds trust" },
        { heading: "Designing brilliance", text: "Use Layouts and Accordions to guide the reader's journey" },
        {
            heading: "Dialling in that brand sparkle",
            text: "Make it interactive. Use accordions and videos to keep clients engaged",
        },
        {
            heading: "Final checks in progress",
            text: "Check that every section ties back to the reader's goals",
        },
    ];
    var almostFinishedMessage = {
        heading: "Almost done",
        text: "Make the ROI undeniable",
    };
    (0, react_1.useEffect)(function () {
        if (progress <= initialProgressLevel) {
            setState("start");
        }
        if (progress > initialProgressLevel && progress < maximumProgressLevel) {
            setState("looping");
        }
        if (progress >= maximumProgressLevel) {
            setState("end");
        }
    }, [progress]);
    (0, react_1.useEffect)(function () {
        if (state === "looping") {
            loopingInterval.current = setInterval(function () {
                setCounter((counter + 1) % 4);
            }, 4000);
        }
        return function () { return clearInterval(loopingInterval.current); };
    }, [counter, state]);
    return (react_1.default.createElement(CrossFade_1.CrossFade, { elementKey: "".concat(state, "-").concat(counter, "}"), withScaleEffect: false },
        react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", gap: "xs" },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "end", gap: "xxxs" },
                react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", strong: true, className: parentStyles.headingColorOverride },
                    state === "start" && uploadStartedMessage.heading,
                    state === "looping" && ((_b = loopingMessages[counter]) === null || _b === void 0 ? void 0 : _b.heading),
                    state === "end" && almostFinishedMessage.heading),
                react_1.default.createElement(LoadingEllipses, null)),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s", className: parentStyles.textColorOverride },
                state === "start" && uploadStartedMessage.text,
                state === "looping" && ((_c = loopingMessages[counter]) === null || _c === void 0 ? void 0 : _c.text),
                state === "end" && almostFinishedMessage.text))));
};
var LoadingEllipses = function () {
    var _a = __read((0, react_1.useState)(0), 2), counter = _a[0], setCounter = _a[1];
    var loopingInterval = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        loopingInterval.current = setInterval(function () {
            setCounter((counter + 1) % 4);
        }, 500);
        return function () { return clearInterval(loopingInterval.current); };
    }, [counter]);
    var maxDots = 3;
    var dots = Array.from(new Array(maxDots));
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xxs", direction: "horizontal", align: "end", className: styles.loadingEllipsisContainer }, dots.map(function (_, index) { return (react_1.default.createElement("div", { className: styles.loadingEllipsis({ visible: counter > index }), key: index })); })));
};
